 //本地接口
import localServer from "@/utils/request.js"
const API_USER = {
  //用户登录接口
  LOGIN: function(username,password){
    return localServer({
      url: "login/",
      method: "post",
      data: {
        username,password
      }
    })
  },

  //获取用户信息接口
  GETINFO : function(){
    return localServer({
      url : "menus/",
      method: "get",
    })
  },

  //退出接口
  logout : function(){
    return localServer({
      url: "logout/",
      method: "get"
    })
  },

  //获取所有用户接口
  FETCH_ALL_USER : function(data){
    return localServer({
      url : "user/",
      method: "get",
      params: data
    })
  },

  // 添加用户
  CREATE_ONE_USER : function(context){
    let {username,password,email,role_id,phone,other,cpy_name,auth_list} = context;
    return localServer({
      url: "user/",
      method: "post",
      data: {
        username,password,email,phone,role_id,other,cpy_name,auth_list
      }
    })
  },

  // 获取单个用户信息
  FETCH_ONE_USER : function(id){
    return localServer({
      url: `user/${id}/`,
      method: "get",
    })
  },

  // 更新一个用户
  UPDATE_ONE_USER : function(id,context){
    let {username,email,phone,other,cpy_name} = context;
    return localServer({
      url: `user/${id}/`,
      method: "put",
      data: {
        username,email,phone,other,cpy_name
      }
    })
  },

  //删除单个用户
  DELETE_ONE_USER : function(id){
    return localServer({
      url: `user/${id}/`,
      method : "delete"
    })
  },

  // 获取所有子用户接口
  FETCH_ALL_KIDUSER : function(querylist){
    return localServer({
      url: "kiduser/",
      method: "get",
      params: querylist
    })
  },

  // 添加子用户接口:
  CREATE_ONE_KIDUSER : function(context){
    return localServer({
      url: "kiduser/",
      method: "post",
      data: context
    })
  },

  //获取单一子用户接口:
  FETCH_ONE_KIDUSER : function(id){
    return localServer({
      url : `kiduser/${id}/`,
      method: "get"
    })
  },

  //更新子用户接口
  UPDATE_ONE_KIDUSER : function(id,context){
    let {username,email,phone,cpy_name,other} = context
    return localServer({
      url: `kiduser/${id}/`,
      method: "put",
      data: {
        username,email,phone,cpy_name,other
      }
    })
  },

  //删除子用户接口
  DELETE_ONE_KIDUSER : function(id){
    return localServer({
      url: `kiduser/${id}/`,
      method: 'delete'
    })
  },
  //重置子用户密码
  RESET_KIDUSER_PWD: function(id){
    return localServer({
      url: "pwdreset/",
      method: "post",
      data: {
          id
      }
    })
  },
  RESET_MY_PWD: function(context){
    let {oldpwd,newpwd,newpwd_confirm} = context
    return localServer({
        url: "pwdupdate/",
        method: "post",
        data: {
          oldpwd: oldpwd,
          newpwd: newpwd,
          surenewpwd: newpwd_confirm
        }
    })
  },
  //获取用户计费组
  FETCH_USER_BILL:function(querylist){
    return localServer({
        url: "user/simbill/",
        method: "get",
        params: querylist
    })
  },

  //获取该客户下的全部套餐
  FETCH_all_BILL: function(){
    return localServer({
      url: "user/simbills/",
      method: "get",
    })
  },

  //获取用户下的所有客户名称(带自身客户)
  FETCH_ALL_CUSTOM: function(){
    return localServer({
      url: "user/companys/",
      method: "get",
    })
  },
  
  //提交订单时，查看msisdn
  CHECK_ORDER_NUMBER: function(number){
    return localServer({
      url: "user/simcheck/",
      method: "post",
      data: {
        msisdn: number
      }
    })
  },
  //支付宝付款时，获取订单号
  GET_SEQUENSE_NUMBER: function(number,amount){
    return localServer({
      url: "alipay/getorder/",
      method: "post",
      data: {
        msisdn: number,
        amount: amount
      }
    })
  },
  //支付宝支付确认
  CONFIRM_ALIPAY : function(sequense,amount){
    return localServer({
      url: "alipay/sure/",
      method: "post",
      data: {
        order_id: sequense,
        amount: amount,
        pay_type: 0
      }
    })
  },
  //支付宝支付结果检查
  ALIPAY_RESULT_CHECK: function(sequense,amount){
    return localServer({
      url: "alipay/check/",
      method: "post",
      data: {
        order_id: sequense,
        amount: amount,
        pay_type: 0
      }
    })
  },
  //获取订单列表
  FETCH_RENEW_ORDERLIST: function(queryList){
    return localServer({
      url: "orders/",
      method: "get",
      params: queryList
    })
  },
  //获取角色
  FETCH_ROLES: function() {
    return localServer({
      url: "user/roles/",
      method: "get",
    })
  },
  //获取销售人员
  FETCH_SALEMEN: function() {
    return localServer({
      url: "user/sales/",
      method: "get",
    })
  }
}

export default API_USER


// WEBPACK FOOTER //
// ./src/api/user.js